import { render, staticRenderFns } from "./OfferPricePage.vue?vue&type=template&id=7fe98d89&scoped=true&"
import script from "./OfferPricePage.vue?vue&type=script&lang=js&"
export * from "./OfferPricePage.vue?vue&type=script&lang=js&"
import style0 from "./OfferPricePage.vue?vue&type=style&index=0&id=7fe98d89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe98d89",
  null
  
)

export default component.exports